// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { LocationFilterModel } from "@store/Framework/Types/ApiModels";

export interface GetLocationFiltersApiParameter extends ApiParameter {}

export async function getLocations(parameter?: GetLocationFiltersApiParameter) {
    const newParam = parameter || {};
    const locations = await get<LocationFilterModel[]>("api/v1/custom/location/filters", newParam);

    return locations;
}
